module.exports = __webpack_public_path__ + "img/rock-huge-05.64e06b11.png";